import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { RadioButtonComponent } from './radio-button.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    RadioButtonComponent
  ],
  exports: [
    RadioButtonComponent,
  ]
})
export class RadioButtonModule {
}
